import { Button, Modal } from "react-bootstrap";
import { CompanyDomainTypes, SharedBox } from "../../types/SharedBox";
import {
    FaPhoneAlt as PhoneIcon,
    FaEnvelope as EmailIcon,

} from 'react-icons/fa';

const COMPANY_DOMAIN_SUPPORT = {
    FIDUCIAL: {
        email: 'drivesupport@fiducial.com',
    },
    FIDUCIAL_JADE: {
        email: 'drivesupport@fiducial.com',
    },
    FIDUCIAL_FEDERATED: {
        phone: '+1 (217) 788-0340',
        email: 'drivesupport@fiducial.com',
    },
};

export const ModalSupport = ({
    sharedBox,
    supportModalStatus = false,
    setSupportModalStatus,
}: {
    sharedBox?: Partial<SharedBox>;
    supportModalStatus: boolean;
    setSupportModalStatus: (status: boolean) => void;
}) => {
    const companyDomain: CompanyDomainTypes = (sharedBox || {}).companyDomain || 'FIDUCIAL';
    const supportInfo: any = COMPANY_DOMAIN_SUPPORT[companyDomain] || {};
    return (
        <Modal
                show={supportModalStatus}
                onHide={() => setSupportModalStatus(false)}
                centered
            >
                <Modal.Body>
                    <div className="text-center display-6 mb-3">Client Support</div>
                    <div className="d-flex justify-content-center mb-3">
                        <table className="">
                            <tbody>
                                {supportInfo.phone ?
                                    <tr>
                                        <td className="text-start fw-bold">
                                            <PhoneIcon className="me-2" size={18} />
                                        </td>
                                        <td className="text-start">
                                            <a href={'tel:' + supportInfo.phone}>{supportInfo.phone || ''}</a>
                                        </td>
                                    </tr> : null
                                }
                                {supportInfo.email ?
                                    <tr>
                                        <td className="text-start fw-bold">
                                            <EmailIcon className="me-2" size={18} />
                                        </td>
                                        <td className="text-start">
                                            <a href={'mailto:' + supportInfo.email}>{supportInfo.email || ''}</a>
                                        </td>
                                    </tr> : null
                                }
                            </tbody>
                        </table>
                    </div>
                    <div className="d-block text-center">
                        <Button variant="primary" onClick={() => setSupportModalStatus(false)}>Close</Button>
                    </div>
                </Modal.Body>
            </Modal>
    )
}


export default ModalSupport;